'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AccessRulesListPage, SETTINGS_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/access-rules/')({
  component: () => <AccessRulesListPage paths={SETTINGS_AUTH_POLICY_PATHS} />
});